import { defineStore } from 'pinia'
import { reactive } from 'vue'
import { ICategory } from './type'

export interface State {
    isOpen: boolean
    activeCategory: ICategory | null
    timeout: number | undefined
    sections: ICategory[]
}

export default defineStore('megamenu', () => {
    const state: State = reactive({
        isOpen: false,
        activeCategory: null,
        timeout: undefined,
        sections: [],
    })

    const open = async () => {
        state.isOpen = true
    }

    const close = async () => {
        stopOpening()
        state.isOpen = false
    }

    const stopOpening = async () => {
        clearTimeout(state.timeout)
    }

    const openCategory = async (category: ICategory) => {
        stopOpening()
        state.timeout = setTimeout(() => {
            state.activeCategory = category
            open()
        }, 200)
    }

    const toggleCategory = async (category: ICategory) => {
        if (state.activeCategory === category) {
            state.activeCategory = null
        } else {
            state.activeCategory = category
        }
        open()
    }

    const setSections = async (sections: ICategory[]) => {
        state.sections = sections
    }

    const isOpen = () => state.isOpen

    const getActiveCategory = () => state.activeCategory

    const getSections = () => state.sections

    return {
        open,
        close,
        stopOpening,
        openCategory,
        toggleCategory,
        setSections,
        getSections,
        isOpen,
        getActiveCategory,
    }
})
